import { useState, useEffect } from "react";
import axios from 'axios';
import { OAuthApiStartPolling } from "../../ExternalApi/OAuthApi"
import { v4 as uuidv4 } from 'uuid'
import { jwtDecode } from 'jwt-decode'
import { proxyUrl, isBeta } from "./Utils.jsx";
import { capitalize } from "lodash";

// Check if user's tenant is registered for his portalId on the Hubspot Proxy server
var msg = ["Loading...", ""];
var showInstallButton = false;
const clientId = "00c79caa-7bc2-4956-a530-c4e9ffd97869";
const clientIdBeta = "a6cc1627-06fe-4f8c-b970-79ad784718f4";
const clientIdbOnline = "73bfef05-ed16-4183-ae80-e6547172633e"
const clientIdbOnlineBeta = "fe1a6a17-fd0b-4bf7-84da-b834d5b6cdef"
function VerifyRegistration(brand) {
    const [repaint, setRepaint] = useState(0);
    useEffect(() => {
        const securityToken = localStorage.getItem("securitytoken");
        const config = { headers: { Authorization: `Bearer ${securityToken}` } };
        const portalId = localStorage.hb_portalId;
        const ctiTenant = jwtDecode(securityToken).TenantGuid;
        if (portalId == undefined) {
            msg = ["Initialisation error", "The app did not receive the required startup information from Hubspot."];
        }
        else {
            axios.get(proxyUrl + "/getSub?portalId=" + portalId, config)
            .then(response => {
                console.log(response);
                if (!response.data) {
                    msg = ["Something went wrong", "The authorisation check did not return a response message."];
                }
                else if (!response.data?.subscribed) {
                    msg = ["Hubspot tenant not authorised", "The app has not been authorized by your HubSpot tenant. Please authorize the app with the button below."];
                    showInstallButton = true;
                }
                else if (!response.data?.tenants.includes(ctiTenant)) {
                    const brandName = brand === "bonline" ? "bOnline" : "CloudCTI";
                    msg = [`${capitalize(brandName)} tenant not associated`, `Your ${brandName} tenant is not associated with your HubSpot tenant. To associate both tenants, reauthorize the app while logged in with your ${brandName} account in HubSpot.`];
                    showInstallButton = true;
                }
                else
                    msg = "valid";
                setRepaint("subResponse");
            }).catch((error) => {
                console.log(error);
                msg = ["Something went wrong", error.toString()];
                setRepaint("subResponseError");
            });
        }
    }, []);

    if (msg != "valid") {
        return <div style={{ width: "100%", padding: "10px" }}>
            <h2 style={{ textAlign: "center" }}>{msg[0]}</h2>
            <p style={{ textAlign: "center" }}>{msg[1]}</p>
            {showInstallButton && <InstallButton></InstallButton>}
        </div>
    }
    return "valid";
    
    function InstallButton() {
        var redirect_base = window.location.href.split("?")[0];
        if (redirect_base.endsWith("/"))
            redirect_base = redirect_base.slice(0, -1); // Remove trailing slash, otherwise HubSpot OAuth will complain
        const installUrl = brand === "bonline" ?
            `https://app.hubspot.com/oauth/authorize?client_id=${isBeta ? clientIdbOnlineBeta : clientIdbOnline}&redirect_uri=${redirect_base}?embedded=hubspotbonline&scope=crm.objects.contacts.write%20oauth%20crm.objects.companies.write%20crm.objects.companies.read%20crm.objects.contacts.read`
            :
            `https://app-eu1.hubspot.com/oauth/authorize?client_id=${isBeta ? clientIdBeta : clientId}&redirect_uri=${redirect_base}?embedded=hubspot&scope=crm.objects.contacts.write%20oauth%20crm.objects.companies.write%20crm.objects.companies.read%20crm.objects.contacts.read`;
        return <div style={{ textAlign: "center" }}>
            <a>
                <button className="btn btn-primary" 
                onClick={() => {
                    const ctiTenant = jwtDecode(localStorage.getItem("securitytoken")).TenantName;
                    const state = "client2020" + uuidv4() + "|" + ctiTenant;

                    const newTab = window.open(installUrl + `&state=${state}`, "_blank");
                    msg = ["Awaiting authorisation", "Please follow the steps in the newly opened window."];
                    showInstallButton = false;
                    
                    // Wait for the user to authorise the app
                    OAuthApiStartPolling(state, OnGetPollResult, newTab);
                    
                    setRepaint("awaitingAuth");
                }}>Reauthorize app</button>
            </a>
        </div>
    }

    function OnGetPollResult(aSuccess, aData, aOAuthWindow) {
        console.log("OnGetPollResult", aSuccess, aData);
        if (aSuccess) {
            if (aData.Code.startsWith("success")) {
                msg = "valid";
                showInstallButton = false;
                aOAuthWindow?.close();
            }
            else {
                msg = ["Something went wrong", "See the authorisation window for details. Please try authorising the app again."];
                showInstallButton = true;
            }
            setRepaint("authResponse");
        }
        else {
            msg = ["Something went wrong", "Encountered an error or timed out while waiting for Authorisation. Please try refreshing the app or authorising again."];
            showInstallButton = true;
            setRepaint("authResponseError");
        }
    }
}


export default VerifyRegistration;